import type { TSize, TKind } from '../models';

export const DEFAULT_SIZE: TSize = '100%';

export const DEFAULT_KIND: TKind = 'white';

export const DEFAULT_TITLE_THEME: TKind = 'white';

export const DEFAULT_MARKER_COLOR = '#121212';
